import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel, getTableNameFull } from './data.model'



export interface ISplash extends IDataModel {
    texto?: string,
    img?: string,
    anunciante?:number,
    link?:string,
    regiao?:any,
}

export class Splash extends DataModel<ISplash>  {
    constructor(private db: AngularFirestore) {
        super(db,'splash');
//        console.log(this.tableNameFull);
    }
}
